export default "__VITE_ASSET__HFoWHE9U__"